module.exports = __webpack_public_path__ + "static/media/5DPO22.e4292c91.jpg";